import { useUserNotificationsSettings } from "../hooks/useUserNotificationsSettings";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useTranslation } from "react-i18next";

export const NotificationsSettings = () => {
    const { t } = useTranslation();
    const { settings, isLoading, handleNotificationsChange } = useUserNotificationsSettings();

    if (isLoading) {
        return <div>{t('common.loading')}</div>;
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t("settings.notifications.title")}</CardTitle>
                <CardDescription>{t("settings.notifications.description")}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
                {/* <div className="flex items-center justify-between">
                    <div>
                        <Label>{t("settings.notifications.push.title")}</Label>
                        <p className="text-sm text-muted-foreground">
                            {t("settings.notifications.push.description")}
                        </p>
                    </div>
                    <Switch
                        checked={settings?.pushEnabled}
                        onCheckedChange={(checked) => handleNotificationsChange('pushEnabled', checked)}
                    />
                </div> */}
                <div className="flex items-center justify-between">
                    <div>
                        <Label>{t("settings.notifications.email.title")}</Label>
                        <p className="text-sm text-muted-foreground">
                            {t("settings.notifications.email.description")}
                        </p>
                    </div>
                    <Switch
                        checked={settings?.emailEnabled}
                        onCheckedChange={(checked) => handleNotificationsChange('emailEnabled', checked)}
                    />
                </div>
                <div className="flex items-center justify-between">
                    <div>
                        <Label>{t("settings.notifications.phoneEnabled")}</Label>
                        <p className="text-sm text-muted-foreground">
                            {t("settings.notifications.phone.description")}
                        </p>
                    </div>
                    <Switch
                        checked={settings?.phoneEnabled}
                        onCheckedChange={(checked) => handleNotificationsChange('phoneEnabled', checked)}
                    />
                </div>
            </CardContent>
        </Card>
    );
};